import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 20,
  height = 20,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || "0 0 20 20"}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    fill="none"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M13.1396 4.44248L7.53958 2.10914C7.369 2.03838 7.18614 2.00195 7.00146 2.00195C6.81678 2.00195 6.63392 2.03838 6.46333 2.10914L0.863333 4.44248C0.34125 4.65831 0 5.16873 0 5.73456C0 11.5241 3.33958 15.5258 6.46042 16.8266C6.80458 16.9696 7.1925 16.9696 7.53667 16.8266C10.0363 15.7854 14 12.1891 14 5.73456C14 5.16873 13.6587 4.65831 13.1396 4.44248ZM7.18083 15.9662C7.06417 16.0129 6.93583 16.0129 6.82208 15.9662C3.96667 14.8346 0.933333 10.8679 0.933333 5.73456C0.933333 5.54498 1.04708 5.37581 1.21917 5.30289L6.81917 2.96956C6.93292 2.92289 7.06417 2.92289 7.17792 2.96956L12.7779 5.30289C12.9529 5.37581 13.0667 5.54498 13.0638 5.73456C13.0667 10.8679 10.0333 14.8346 7.18083 15.9662ZM7 13.9887V4.91789L2.83792 6.65331C3.1325 10.1562 5.08667 12.9241 7 13.9887ZM6.06667 12.0404C5.005 10.8766 4.1475 9.18789 3.84708 7.24248L6.06667 6.31789V12.0404Z"
      fill="var(--tlx-cta-primary-default)"
    />
    <circle cx="13" cy="14" r="5" fill="var(--tlx-surface-bg-surface)" />
    <g clipPath="url(#clip0_5959_68637)">
      <path
        d="M13.0007 9.83325C15.3019 9.83325 17.1673 11.6987 17.1673 13.9999C17.1673 16.3012 15.3019 18.1666 13.0007 18.1666C10.6994 18.1666 8.83398 16.3012 8.83398 13.9999C8.83398 11.6987 10.6994 9.83325 13.0007 9.83325ZM13.0007 11.9166C12.9251 11.9166 12.8522 11.9439 12.7953 11.9936C12.7384 12.0432 12.7013 12.1118 12.6911 12.1866L12.6882 12.2291V13.6874H11.2298C11.1506 13.6874 11.0744 13.7175 11.0166 13.7716C10.9587 13.8256 10.9235 13.8996 10.9181 13.9786C10.9127 14.0576 10.9375 14.1357 10.9875 14.1971C11.0375 14.2585 11.1089 14.2987 11.1873 14.3095L11.2298 14.3124H12.6882V15.7708C12.6882 15.8499 12.7183 15.9261 12.7723 15.984C12.8264 16.0419 12.9004 16.077 12.9794 16.0824C13.0583 16.0878 13.1364 16.063 13.1979 16.0131C13.2593 15.9631 13.2994 15.8917 13.3102 15.8133L13.3132 15.7708V14.3124H14.7715C14.8507 14.3124 14.9269 14.2823 14.9847 14.2283C15.0426 14.1742 15.0778 14.1002 15.0832 14.0212C15.0886 13.9422 15.0638 13.8641 15.0138 13.8027C14.9638 13.7413 14.8924 13.7011 14.814 13.6903L14.7715 13.6874H13.3132V12.2291C13.3132 12.1462 13.2802 12.0667 13.2216 12.0081C13.163 11.9495 13.0835 11.9166 13.0007 11.9166Z"
        fill="var(--tlx-cta-primary-default)"
      />
    </g>
    <defs>
      <clipPath id="clip0_5959_68637">
        <rect width="10" height="10" fill={fill} transform="translate(8 9)" />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
